import { getAnalytics, logEvent, setUserId } from "firebase/analytics";
import { FirebaseApp, initializeApp } from "firebase/app";
import {
  getRemoteConfig,
  type RemoteConfig,
  getValue as getFirebaseValue,
  fetchAndActivate,
} from "firebase/remote-config";
import { Environment, getFirebaseConfigForEnv } from "./const";

const genRemoteConfig = () => {
  let remoteConfig: RemoteConfig;

  return (app?: FirebaseApp) => {
    if (remoteConfig) {
      return remoteConfig;
    }
    remoteConfig = getRemoteConfig(app);
    return remoteConfig;
  };
};

const getFirebaseConfig = genRemoteConfig();

// Initialize Firebase
export async function initFirebase(env: Environment, _firebaseEnv?: any) {
  // 使用动态配置函数，支持 iOS PWA 环境下的 authDomain 切换
  const firebaseConfig = getFirebaseConfigForEnv(env);
  const app = initializeApp(firebaseConfig);
  getAnalytics(app);
  const remoteConfig = getFirebaseConfig(app);
  remoteConfig.settings.minimumFetchIntervalMillis = 1;
  remoteConfig.defaultConfig = {};
  await fetchAndActivate(remoteConfig);
}

export function logEventAnalytics(eventName: any, params?: any) {
  const analytics = getAnalytics();
  const name = "ai-chat";

  return logEvent(analytics, `${name}_${eventName}`, params);
}

/** page and screen */
export function logScreenView(
  params:
    | {
        [key: string]: any;
        firebase_screen: string | undefined;
        firebase_screen_class: string | undefined;
      }
    | undefined,
) {
  const analytics = getAnalytics();

  return logEvent(analytics, "screen_view", params);
}

export const logSetUserId = async (userId: string) => {
  const analytics = getAnalytics();

  try {
    return setUserId(analytics, userId);
  } catch (e) {
    return e;
  }
};

export const getValue = async (key: string) => {
  const remoteConfig = getFirebaseConfig();
  await fetchAndActivate(remoteConfig);

  return getFirebaseValue(remoteConfig, key);
};
